import { readCookie } from '@components/common';
import PasswordRecovery from '@components/forgotPassword';
import { MetaTags } from '@components/metaComponent';
import { IDeviceType } from '@components/shared.types';
import { deviceTypeByUserAgent } from '@license-admin/boldjobs';
import { getLocalizationAndConfig } from 'API/jobs';
import { initializeAccounts } from 'helper/accounts';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import { useEffect } from 'react';

type Props = {
  localization: any;
  config: any;
  headerSearch?: boolean;
  deviceType: IDeviceType;
  isEmployerLogin: boolean;
};

export default function ForgotPassword(props: Props) {
  const { localization, config, deviceType, isEmployerLogin } = props;

  useEffect(() => {
    const createGuestUser = async () => {
      initializeAccounts();
    };
    createGuestUser();
  }, []);

  return (
    <>
      <Head>
        {MetaTags({
          localization,
        })}
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <PasswordRecovery
        localization={localization}
        config={config}
        deviceType={deviceType}
        isEmployerLogin={isEmployerLogin}
      />
    </>
  );
}

export const getServerSideProps: GetServerSideProps<Props> = async ({
  query,
  req,
}) => {
  const [localization, config] = await getLocalizationAndConfig(
    'forgot_password'
  );
  let isEmployerLogin = false;
  const deviceType: IDeviceType = deviceTypeByUserAgent(
    req.headers['user-agent'] || ''
  );

  if (query && query.emp) {
    isEmployerLogin = true;
  }

  return {
    props: {
      isEmployerLogin: isEmployerLogin,
      localization: localization,
      config: config,
      deviceType: deviceType,
      headerSearch: true,
      themeType: readCookie('theme', req.headers.cookie) || 'graphite',
    },
  };
};
